import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=09f78bbd&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=ts"
export * from "./Keyboard.vue?vue&type=script&lang=ts"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=09f78bbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f78bbd",
  null
  
)

export default component.exports